import { render, staticRenderFns } from "./UserPage.vue?vue&type=template&id=62419e06&scoped=true&"
import script from "./UserPage.vue?vue&type=script&lang=js&"
export * from "./UserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62419e06",
  null
  
)

export default component.exports